/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Props {
  className: any;
}

export const UnsavedIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask height="20" id="mask0_601_4954" maskUnits="userSpaceOnUse" width="20" x="0" y="0">
        <rect fill="#D9D9D9" height="20" width="20" />
      </mask>
      <g mask="url(#mask0_601_4954)">
        <path
          d="M10 17.4999L8.79169 16.4166C7.38891 15.1527 6.22919 14.0624 5.31252 13.1458C4.39585 12.2291 3.66669 11.4062 3.12502 10.677C2.58335 9.94784 2.20488 9.2777 1.9896 8.66658C1.77433 8.05547 1.66669 7.43047 1.66669 6.79158C1.66669 5.48603 2.10419 4.39575 2.97919 3.52075C3.85419 2.64575 4.94446 2.20825 6.25002 2.20825C6.97224 2.20825 7.65974 2.36103 8.31252 2.66659C8.9653 2.97214 9.5278 3.4027 10 3.95825C10.4722 3.4027 11.0347 2.97214 11.6875 2.66659C12.3403 2.36103 13.0278 2.20825 13.75 2.20825C15.0556 2.20825 16.1459 2.64575 17.0209 3.52075C17.8959 4.39575 18.3334 5.48603 18.3334 6.79158C18.3334 7.43047 18.2257 8.05547 18.0104 8.66658C17.7952 9.2777 17.4167 9.94784 16.875 10.677C16.3334 11.4062 15.6042 12.2291 14.6875 13.1458C13.7709 14.0624 12.6111 15.1527 11.2084 16.4166L10 17.4999ZM10 15.2499C11.3334 14.0555 12.4306 13.0312 13.2917 12.177C14.1528 11.3228 14.8334 10.5798 15.3334 9.94784C15.8334 9.31589 16.1806 8.75339 16.375 8.26034C16.5695 7.76728 16.6667 7.2777 16.6667 6.79158C16.6667 5.95825 16.3889 5.26381 15.8334 4.70825C15.2778 4.1527 14.5834 3.87492 13.75 3.87492C13.0972 3.87492 12.4931 4.05895 11.9375 4.427C11.382 4.79506 11 5.26381 10.7917 5.83325H9.20835C9.00002 5.26381 8.61808 4.79506 8.06252 4.427C7.50697 4.05895 6.9028 3.87492 6.25002 3.87492C5.41669 3.87492 4.72224 4.1527 4.16669 4.70825C3.61113 5.26381 3.33335 5.95825 3.33335 6.79158C3.33335 7.2777 3.43058 7.76728 3.62502 8.26034C3.81946 8.75339 4.16669 9.31589 4.66669 9.94784C5.16669 10.5798 5.84724 11.3228 6.70835 12.177C7.56947 13.0312 8.66669 14.0555 10 15.2499Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
